export default __webpack_public_path__ + "static/media/np.e647a99a.svg";